<section class="title-logos">
  <div class="title-logos__side title-logos__side--left">
    <img
      class="title-logos__logo"
      src="assets/logos/logo-title-1.png"
      alt="Social Innovation + Initiative"
    />
    <img
      class="title-logos__logo"
      src="assets/logos/logo-title-2.png"
      alt="Co-funded by the European Union"
    />
  </div>

  <div class="title-logos__text">
    <h1 class="title-logos__title">
      {{ 'titleLogos.titleLine1' | translate }}<br />{{ 'titleLogos.titleLine2' | translate }}
    </h1>
    <p class="title-logos__subtitle">{{ 'titleLogos.subtitle' | translate }}</p>
  </div>

  <div class="title-logos__side title-logos__side--right">
    <img
      class="title-logos__logo"
      src="assets/logos/logo-title-3.png"
      alt="Jesuit Refugee Service Europe"
    />
    <img class="title-logos__logo" src="assets/logos/logo-title-4.png" alt="SMART UA" />
  </div>
</section>
